import { useEffect } from 'react'
import {
  CardContainer,
  Container,
  ContentContainer,
  ContentContainerColumn,
  Form,
  FormHeading,
  FormSection,
  HeadingContainer,
} from 'uikit/layout'
import { CheckboxForm, Heading, InputForm, Button } from 'uikit'
import { useHistory, useParams } from 'react-router-dom'
import { Field, Formik } from 'formik'
import * as Yup from 'yup'
import { useUserItemFetch } from './services/useUserItemFetch'
import { useUserItemCreate } from './services/useUserItemCreate'
import { Password } from './components/Password/Password'
import { Role } from './components/Role/Role'
import { useUserItemUpdate } from './services/useUserItemUpdate'
import { Delete } from './components/Delete/Delete'

const formSchema = Yup.object().shape({
  username: Yup.string().required('Обязательное поле'),
})

export const AccessUpdate = () => {
  const { id } = useParams()
  const isNew = !id
  const history = useHistory()

  const { data, refetch: fetchItem, isLoading: isLoadingFetchItem } = useUserItemFetch(id)
  const { mutate: createItem, isLoading: isLoadingCreateItem } = useUserItemCreate()
  const { mutate: updateItem, isLoading: isLoadingUpdateItem } = useUserItemUpdate(id)

  const isLoading = isLoadingFetchItem || isLoadingCreateItem || isLoadingUpdateItem
  const isReadOnly = id === 'aa5ecb7e-f037-4a8d-a185-f8ed1890fefb'

  const handleBack = () => {
    history.goBack()
  }

  const handleForm = (values) => {
    if (isNew) {
      createItem(values, {
        onSuccess: () => {
          history.goBack()
        }
      })
    } else {
      updateItem(values, {
        onSuccess: () => {
          fetchItem()
        }
      })
    }
  }


  return (
    <Container>
      <CardContainer onBack={handleBack} indentTop={70}>
        <ContentContainer>
          <ContentContainerColumn>
            <HeadingContainer>
              <Heading>{isNew ? 'Создание пользователя' : 'Обновление пользователя'}</Heading>
              {!isNew && <Delete id={id} isReadOnly={isReadOnly} />}
            </HeadingContainer>
            <Formik
              initialValues={{
                username: data?.data?.username,
                enabled: data?.data?.enabled,
              }}
              enableReinitialize
              onSubmit={handleForm}
              validationSchema={formSchema}
            >
              {(props) => (
                <Form
                  onSubmit={props.handleSubmit}
                  footer={
                    <Button
                      type="submit"
                      colorPalette="orange"
                      disabled={!props.isValid}
                      loading={isLoading}
                    >
                      {isNew ? 'Создать' : 'Обновить'}
                    </Button>
                  }
                >
                  <FormSection>
                    <Field
                      name="username"
                      component={InputForm}
                      label="Логин"
                      disabled={isLoading || isReadOnly}
                    />
                    <Field
                      name="enabled"
                      component={CheckboxForm}
                      label="Активен"
                      disabled={isLoading || isReadOnly}
                    />
                  </FormSection>
                  {!isNew && (
                    <>
                      <FormSection>
                        <FormHeading>Пароль</FormHeading>
                        <Password id={id} />
                      </FormSection>
                      {!isReadOnly && (
                        <FormSection>
                          <FormHeading>Роли</FormHeading>
                          <Role id={id} />
                        </FormSection>
                      )}
                    </>
                  )}
                </Form>
              )}
            </Formik>
          </ContentContainerColumn>
        </ContentContainer>
      </CardContainer>
    </Container>
  )
}
